<template>
  <ConfirmModal
    v-if="showModal"
    :show-approve="false"
    :show-cancel="false"
    :hide-actions="true"
    :show-floating-close-button="true"
    wrapper-class="max-w-2xl"
    @close-dialog="closeModal"
  >
    <template #content>
      <div class="p-6">
        <div>
          <img v-if="fencingImageLink" :src="fencingImageLink" alt="Moody Image" class="w-2/4" />
          <div class="pt-2 txt-headline-l">{{ headline }}</div>
          <div ref="htmlContainer" class="pt-2 txt-body-m text-main" v-html="body"></div>
        </div>
        <div class="flex justify-end gap-4 pt-6">
          <a
            v-if="ctaSecondaryLink"
            :href="ctaSecondaryLink"
            target="_blank"
            class="btn-secondary-color-s"
            data-testid="reviews-outlink-secondary"
            @click="closeModal"
          >
            {{ ctaSecondaryLabel }}
          </a>
          <button
            v-else-if="ctaSecondaryLabel"
            type="button"
            class="btn-secondary-color-s"
            data-testid="reviews-outlink-secondary"
            @click="closeModal"
          >
            {{ ctaSecondaryLabel }}
          </button>
          <a
            v-if="ctaPrimaryLink"
            :href="ctaPrimaryLink"
            target="_blank"
            class="btn-primary-color-s"
            data-testid="reviews-outlink-primary"
            @click="handlePrimaryClick"
          >
            <component :is="ctaPrimaryIcon" v-if="ctaPrimaryIcon" class="lucide-icon-s" />
            {{ ctaPrimaryLabel }}
          </a>
        </div>
      </div>
    </template>
  </ConfirmModal>
</template>

<script setup lang="ts">
import type { LucideIcon } from '@ramp106/omrjs-core-ui/icons'
import { ref } from 'vue'

import ConfirmModal from '@/components/ConfirmModal.vue'

defineProps<{
  headline: string
  body: string
  ctaPrimaryLabel?: string
  ctaPrimaryLink?: string
  ctaPrimaryIcon?: LucideIcon
  ctaSecondaryLabel?: string
  ctaSecondaryLink?: string
  fencingImageLink?: string
}>()

const emit = defineEmits<{
  'cta-primary-click': []
}>()

const showModal = ref(false)

function show() {
  showModal.value = true
}

function closeModal() {
  showModal.value = false
}

function handlePrimaryClick() {
  emit('cta-primary-click')
  closeModal()
}

defineExpose({
  show,
})
</script>
